var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTexas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.474 5.29105C20.3719 4.20506 20.4128 2.87493 20.4128 1.26278C20.4128 0.56541 19.8642 0 19.1876 0H11.6242C10.9476 0 10.399 0.56541 10.399 1.26278V16.3193L2.32516 16.3783C0.609919 16.3783 -0.909294 16.5424 0.650758 18.3735C1.62273 19.531 3.583 21.3242 5.88633 25.0788C8.36526 29.1155 10.4276 28.2568 11.3669 27.1835C13.3027 24.9736 15.2466 23.4246 17.3948 27.8527C18.6444 30.4414 19.6573 32.7102 20.9314 34.6507L20.617 14.4462L20.474 5.29105Z",
    fill: "#01337D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6718 19.4244C39.0662 18.3057 38.6727 17.0787 38.512 15.8086H38.3568H21.9558L22.2498 34.6156C22.2609 35.0567 22.0609 35.4754 21.7148 35.7353C22.992 37.4095 24.6462 38.7374 26.5339 39.6036C28.9025 40.7106 28.2573 37.1622 28.1674 34.725C28.0776 32.2879 33.2233 27.6282 36.3352 26.9632C39.4472 26.2981 40.6397 21.0702 39.6718 19.4244Z",
    fill: "#01337D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3472 14.4453C38.2928 13.7718 38.2655 13.0618 38.2655 12.3154C38.2655 9.3226 32.2417 9.43204 28.2599 9.43204C24.8703 9.43204 22.9508 9.09109 21.8359 8.28711L21.934 14.4453H38.3472Z",
    fill: "#01337D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexas);
export default __webpack_public_path__ + "static/media/Texas.d5adb22a3477fec33d27c05b7814e88b.svg";
export { ForwardRef as ReactComponent };